$(document).on('click', '.copy-url', (event) => {
  event.preventDefault()
  var url = event.target.dataset["url"]
  var tempInput =  $("<textarea>");
  $("body").append(tempInput);
  tempInput.val(url).select();
  document.execCommand("copy");
  tempInput.remove();
})
